<template>
  <div class="highlight-wrap">
    <div
      v-on-display="{ sectionInfo, context: this }"
      class="multi highlight-band"
      :style="`background-image:url(${blurImage}`"
    >
      <div class="highlight-band-meta">
        <h1 tabindex="0" class="highlight-band-txt">
          <span v-if="hasMainTitleA">{{ mainTitleA }}</span>
          <span v-if="hasMainTitleB">{{ mainTitleB }}</span>
        </h1>
        <div class="highlight-band-subtitle">
          <p v-if="hasSubTitle" v-html="subTitle"></p>
        </div>
        <a
          href="#"
          class="highlight-band-more"
          @click.prevent="viewMore(sectionInfo)"
          >{{ cta }}</a
        >
      </div>
      <div class="highlight-band-multi">
        <CellList
          v-if="cellList.length > 0"
          :cell-list="cellList"
          :thumbnail-info="thumbnailInfo"
          cell-type="band_highlight"
        />
      </div>
    </div>
  </div>
</template>
<script>
  import { ref, reactive, computed } from 'vue'
  import { onDisplay } from '@/common/resources/directives'
  import MultiSectionMixin from '@/mixins/multisection.mixin'
  import CellList from '@/components/band/CellList.vue'
  import { resizeThumbnail } from '@/common/utils/image'
  import { convertBand } from '@/common/converter/convert-band'

  export default {
    components: {
      CellList,
    },
    directives: {
      onDisplay,
    },
    mixins: [MultiSectionMixin],
    props: {
      catalogInfo: {
        type: Object,
        default: () => {},
      },
      sectionInfo: {
        type: Object,
        default: () => {},
      },
      thumbnailInfo: {
        type: Object,
        default: () => {},
      },
    },
    setup(props) {
      const band = ref({})
      const cellList = ref([])
      const cta = ref('더보기')
      const titleList = ref([])
      const bandInfo = ref({})
      const cellTopList = ref({})
      const blurImage = ref('')
      const mainTitleA = ref('')
      const mainTitleB = ref('')
      const subTitle = ref('')
      const blur = reactive({
        width: 1240,
        height: 444,
        option: 'b20',
        quality: 100,
      })

      const hasMainTitleA = computed(() => mainTitleA.value !== '')
      const hasMainTitleB = computed(() => mainTitleB.value !== '')
      const hasSubTitle = computed(() => subTitle.value !== '')

      const setTitle = (titleList) => {
        const [titleA, titleB, titleSub] = titleList.map((title) => title?.text)
        mainTitleA.value = titleA ?? ''
        mainTitleB.value = titleB ?? ''
        subTitle.value = titleSub?.replaceAll('\n', '<br>') ?? ''
      }

      const setData = async () => {
        try {
          band.value = await convertBand(props.catalogInfo)
          bandInfo.value = band.value?.band ?? {}
          cellList.value = band.value?.band?.celllist ?? []
          cellTopList.value = band.value?.cell_toplist ?? {}
          cta.value = cellTopList.value?.cta || '더보기'
          titleList.value = cellTopList.value?.title_list ?? []
          blurImage.value = resizeThumbnail(
            cellTopList.value?.blurtarget_img ?? '',
            {
              width: blur?.width,
              height: blur?.height,
              option: blur?.option,
              quality: blur?.quality,
            },
          )

          setTitle(titleList.value)
        } catch (e) {
          console.log('error', e.message)
        }
      }

      setData()

      return {
        cellList,
        cta,
        titleList,
        bandInfo,
        cellTopList,
        blurImage,
        blur,
        mainTitleA,
        mainTitleB,
        subTitle,
        hasMainTitleA,
        hasMainTitleB,
        hasSubTitle,
      }
    },
  }
</script>
<style lang="scss" scoped>
  .highlight-wrap {
    padding: 0 100px 80px;
    .multi.highlight-band {
      width: 100%;
      margin: 0;
      .highlight-band-meta {
        max-width: inherit;
        width: 380px;
        flex: none;
      }
      .highlight-band-multi {
        flex: 1;
        margin-left: 60px;
      }
      .swiper-container {
        min-width: inherit;
        min-height: inherit;
        padding: 0 60px 0 0;
        &:after,
        &:before {
          display: none;
        }
      }
    }
  }
</style>
